import LogoutIcon from '@mui/icons-material/Logout';
import MenuIcon from '@mui/icons-material/Menu';
import PersonIcon from '@mui/icons-material/Person';
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography,
  useMediaQuery,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { useLocation } from 'react-router-dom';
import logo from '../assets/logoWhite.svg';
import profileLogo from '../assets/profileWhite.svg';
import { LinksGroup } from '../components/NavBar/LinksGroup';
import { NavLinksGroup } from '../components/NavBar/NavLinksGroup';
import { logout } from '../config/auth/userSlice';
import { generateMenuByAccess } from '../Utils/menuBuilder';
import AppSidebar from './AppSlider';

const HEADER_HEIGHT = 64;

export default function AppHeader() {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  const user = useSelector((state: any) => state.user?.user);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const role = user?.scope;
  const category = user?.category;
  const location = useLocation();

  const normalizePath = (value: string) =>
    value.replace(/\/+$/, '').toLowerCase() || '/';

  const isActiveRoute = (items: any[]) => {
  const currentPath = normalizePath(location.pathname);

  return items.some((item) => normalizePath(item.path) === currentPath);
};

  const handleLogout = () => {
    dispatch(logout());
    // remove the storeList from local storage
    localStorage.removeItem('storeList');
    navigate('/login');
  };
  const groupedRoutes = generateMenuByAccess(user?.scope, user?.category);
  const [openedGroup, setOpenedGroup] = useState<string | null>(null);
  const handleToggle = (group: string) => {
    setOpenedGroup((prev) => (prev === group ? null : group));
  };

  const links = Object.entries(groupedRoutes).map(([groupLabel, items]) => (
    <LinksGroup
      key={groupLabel}
      label={groupLabel}
      icon={items[0]?.icon}
      links={items}
      access={user?.scope}
      category={user?.category}
      accessCategory={user?.category}
    />
  ));

  const menuItems = Object.entries(groupedRoutes).map(([groupLabel, items]) => (
    <NavLinksGroup
      key={groupLabel}
      label={groupLabel}
      icon={items[0]?.icon}
      links={items}
      opened={openedGroup === groupLabel}
      onToggle={() => handleToggle(groupLabel)}
      access={user?.scope}
      category={user?.category}
      accessCategory={user?.category}
      isActve={isActiveRoute(items)}
    />
  ));
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          height: HEADER_HEIGHT,
          justifyContent: 'center',
          backgroundColor: '#036a85',
          zIndex: theme.zIndex.drawer + 1,
        }}
      >
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            {!isDesktop && (
              <IconButton color="inherit" onClick={() => setDrawerOpen(true)}>
                <MenuIcon />
              </IconButton>
            )}

            <Box
              component="img"
              src={logo}
              alt="logo"
              sx={{ height: 38, cursor: 'pointer' }}
              onClick={() => navigate('/')}
            />
          </Box>

          {isDesktop && (
            <Box sx={{ display: 'flex', gap: 3 }}>
              {/* {Object.entries(groupedDesktopRoutes).map(([group, items]) => (
                <Box key={group} sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                  <Typography variant="body2" sx={{ color: '#fff', fontWeight: 700 }}>
                    {group}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 1 }}>
                    {items.map((item) => (
                      <Typography
                        key={item.path}
                        onClick={() => navigate(item.path)}
                        sx={{
                          color: '#fff',
                          cursor: 'pointer',
                          fontSize: 14,
                          '&:hover': { opacity: 0.8 },
                        }}
                      >
                        {item.label === 'G2000' ? user?.company : item.label}
                      </Typography>
                    ))}
                  </Box>
                </Box>
              ))} */}
              {menuItems}
            </Box>
          )}

          <Box
            onClick={(e) => setAnchorEl(e.currentTarget)}
            sx={{ display: 'flex', alignItems: 'center', gap: 1, cursor: 'pointer' }}
          >
            <Avatar src={profileLogo} />
            {isDesktop && (
              <Box>
                <Typography variant="body2" sx={{ color: '#fff' }}>
                  {user?.first_name}
                </Typography>
                <Typography variant="caption" sx={{ color: '#d7eef3' }}>
                  {user?.location}
                </Typography>
              </Box>
            )}
          </Box>
        </Toolbar>
      </AppBar>

      <Toolbar sx={{ minHeight: `${HEADER_HEIGHT}px !important` }} />

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            navigate('/profile');
          }}
        >
          <PersonIcon sx={{ mr: 1 }} /> Profile
        </MenuItem>
        <MenuItem
          onClick={() => {
            setAnchorEl(null);
            handleLogout();
          }}
        >
          <LogoutIcon sx={{ mr: 1 }} /> Logout
        </MenuItem>
      </Menu>

      <AppSidebar
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        role={role}
        category={category}
      />
    </>
  );
}

export { HEADER_HEIGHT };
